import React from "react";

const badge =
  "inline-flex items-center max-w-[220px] truncate px-2 py-0.5 rounded-full text-xs font-medium border";

function labelOrDash(v) {
  if (v == null || String(v).trim() === "") return "—";
  return String(v).trim();
}

/** Order type / lane type — uses API `order_type_name` or `order_type`. */
export function freightOrderTypeBadgeCell(row) {
  const text = row?.order_type_name ?? row?.order_type;
  const t = labelOrDash(text);
  if (t === "—") return <span className="text-gray-400">—</span>;
  return (
    <span className={`${badge} border-slate-200 bg-slate-50 text-slate-700`} title={t}>
      {t}
    </span>
  );
}

const STATUS_STYLES = {
  "0": "border-amber-200 bg-amber-50 text-amber-900",
  "1": "border-emerald-200 bg-emerald-50 text-emerald-900",
  "2": "border-red-200 bg-red-50 text-red-900"
};

/** Status badge from `order_status` code + optional `order_status_name`. */
export function freightOrderStatusBadgeCell(row) {
  const code = row?.order_status != null ? String(row.order_status).trim() : "";
  const name = row?.order_status_name != null ? String(row.order_status_name).trim() : "";
  const text = name || code || "—";
  if (text === "—") return <span className="text-gray-400">—</span>;
  const cls = STATUS_STYLES[code] || "border-gray-200 bg-gray-50 text-gray-800";
  return (
    <span className={`${badge} ${cls}`} title={name ? `${name} (${code || "?"})` : text}>
      {name || `Status ${code}`}
    </span>
  );
}
